import { HSA, LSA } from 'common/spending-accounts';

export const isTypeHsaOrLsa = (cardType: string | undefined) =>
  cardType === LSA || cardType === HSA;
